import { HttpClient, isApiError } from '@/shared';
import AmendmentStatusResponseDto from '../../../section-1/infra/repositories/dto/res/AmendmentStatusResponseDto';
import { mapAmendmentStatusDtoToEntity } from '../../../section-1/infra/repositories/mappers/amendmentStatusMapper';
import AmendmentStatus from '@/features/section-1/application/domain/entities/AmendmentStatus';
import IRemoteI9AmendmentRepository from '../../application/ports/outbound/IRemoteI9AmendmentRepository';

/**
 * API Amendment Repository Implementation
 * Handles HTTP calls to fetch amendment status
 */
export class ApiRemoteI9AmendmentRepository implements IRemoteI9AmendmentRepository {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Fetch amendment status from API
   * GET /core/api/i9Form/{i9FormId}/amendment-status
   *
   * Response wrapper format:
   * {
   *   statusCode: 200,
   *   message: "Success",
   *   data: { isAmendmetnInProgress: boolean, amendmentReason: string }
   * }
   */
  async fetchAmendmentStatus(): Promise<AmendmentStatus | null> {
    try {
      const response = await this.httpClient.get<AmendmentStatusResponseDto>(
        `/remote-i9/amendment-status`
      );
      return response.data ? mapAmendmentStatusDtoToEntity(response.data) : null;
    } catch (error) {
      // HttpClient has already reported a failed request; logging it again filed it twice (VTK-1860).
      if (!isApiError(error)) console.error('Failed to fetch amendment status:', error);
      return null; // Return null on error to allow graceful degradation
    }
  }
}

export default ApiRemoteI9AmendmentRepository;
